import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { ICONS } from '../../config/config';
import { authFlowDebug } from '../../../../debug/authFlowDebug';

const LoadPercentLabel = ({ isVisible }) => {
  const percentLoaded = useSelector((store) => store.play.isPercentLoaded);
  if (!isVisible || percentLoaded >= 100) return null;
  return (
    <span className="pc-loaded" aria-live="polite">
      <span className="italic bold">{percentLoaded.toFixed()}% loaded</span>
    </span>
  );
};

const SinglePlayerButton = memo(({ onClick }) => {
  const { CONTROLLER } = ICONS;

  return (
    <button
      className="free-trial btn btn-success btn-lg"
      onClick={onClick}
      style={{ paddingTop: 0, minWidth: '220px' }}
    >
      <img
        src={CONTROLLER} alt="Loggin" width="54"
        style={{ float: 'left', marginTop: '10px' }}
      /> &nbsp;
      <p style={{ marginTop: '-5px', fontSize: '16px', lineHeight: '30px' }}>
        <span>SINGLE PLAYER</span>
      </p>
    </button>
  );
});

const MultiplayerButton = memo(({ onClick }) => {
  const { CONTROLLER } = ICONS;

  return (
    <button
      className="free-trial btn btn-success btn-lg"
      onClick={onClick}
      style={{ paddingLeft: 0, minWidth: '220px' }}
    >
      <div style={{ float: 'left', marginLeft: '35px' }}>
        <img
          src={CONTROLLER} alt="Loggin" width="54"
          style={{ marginLeft: '-30px' }}
        /> &nbsp;
        <img
          src={CONTROLLER} alt="Loggin" width="54"
          style={{ marginLeft: '-23px' }}
        />
      </div>
      <p style={{ marginTop: '5px', lineHeight: '30px' }}>
        <span style={{ fontSize: '15px' }}>MULTIPLAYER</span>
      </p>
    </button>
  );
});

export const PlayerMode = ({ singleplayerHandler, multiplayerHandler, mode }) => {
  const isPvp = localStorage.getItem('lastGameModePlayed') !== 'pve'; // assumes default is pvp (ls empty)
  authFlowDebug('playerMode.render', {
    mode,
    isPvp,
    lastGameModePlayed: localStorage.getItem('lastGameModePlayed'),
    unityLoadCompleted: window.unityLoadCompleted,
    loadMissingPc: window.loadMissingPc,
  });

  return (<>
    <div className="col-2"></div>
    <div id={`${mode}-btn-wrap-pve`} className="col-4 text-center">
      <div className="free-wrapper">
        <SinglePlayerButton onClick={singleplayerHandler} />
        <LoadPercentLabel isVisible={!isPvp} />
      </div>
    </div>
    <div
      id={`${mode}-btn-wrap-pvp`} className="col-4 text-center"
      style={{ marginLeft: '10px' }}
    >
      <div className="free-wrapper">
        <MultiplayerButton onClick={multiplayerHandler} />
        <LoadPercentLabel isVisible={isPvp} />
      </div>
    </div>
  </>);
};
